export const actionsPrefix = 'ORDER_LIST_FILTER'

export const TOGGLE_SELECT_FILTER = `${actionsPrefix}/TOGGLE_SELECT_FILTER`
export const TOGGLE_DESELECT_ALL_FILTERS = `${actionsPrefix}/TOGGLE_DESELECT_ALL_FILTERS`
export const APPLY_SELECTED_FILTERS = `${actionsPrefix}/APPLY_SELECTED_FILTERS`
export const APPLY_SEARCH_FILTER = `${actionsPrefix}/APPLY_SEARCH_FILTER`
export const SET_APPLIED_FILTERS_TO_CREATED_BY_RETAILERS = `${actionsPrefix}/SET_APPLIED_FILTERS_TO_CREATED_BY_RETAILERS`
export const TOGGLE_UNASSIGNED_ORDERS_FILTER = `${actionsPrefix}/TOGGLE_UNASSIGNED_ORDERS_FILTER`
export const VERSION_CODE = 3
